import { Box, TextField } from "@mui/material";
import {
  Controller,
  type Control,
  type FieldValues,
  type Path,
} from "react-hook-form";
import { DynamicFormErrorTooltip } from "./DynamicFormErrorTooltip";
import { DynamicFormRequiredLabel } from "./DynamicFormRequiredLabel";

type Props<T extends FieldValues> = {
  control: Control<T, unknown, T>;
  name: Path<T>;
  required?: boolean;
  isSingleLine?: boolean | null;
  onAnswer?: () => void;
};

export const DynamicFormTextArea = <T extends FieldValues>(props: Props<T>) => {
  return (
    <Box sx={{ mt: 1 }}>
      <Controller
        control={props.control}
        name={props.name}
        rules={{
          required: props.required ? "This field is required" : false,
        }}
        render={({ field, fieldState }) => {
          return (
            <>
              <DynamicFormRequiredLabel required={props.required} />
              <DynamicFormErrorTooltip fieldState={fieldState} />
              <Box
                sx={{
                  "& .MuiInputBase-root.MuiOutlinedInput-root": {
                    borderRadius: "8px",
                  },
                }}
              >
                <TextField
                  placeholder=""
                  sx={(theme) => ({
                    width: "100%",
                    borderColor: fieldState.error
                      ? theme.palette.error.main
                      : undefined,
                  })}
                  variant="outlined"
                  error={!!fieldState.error}
                  multiline
                  minRows={props.isSingleLine ? 1 : 3}
                  {...field}
                  value={field.value[0]?.text ?? ""}
                  onChange={(e) => {
                    const value = e.currentTarget.value;
                    const obj = [{ id: -1, text: value }];
                    field.onChange(obj);
                  }}
                  onBlur={() => {
                    field.onBlur();
                    if (field.value[0]?.text) {
                      props.onAnswer?.();
                    }
                  }}
                />
              </Box>
            </>
          );
        }}
      />
    </Box>
  );
};
